module.exports = __webpack_public_path__ + "d9e27a06e72be6ddc72719d483340cef.png";